import {
  triggerButtonClickedAPIEvent,
  triggerMeetingRequestedAPIEvent,
  triggerMessageReceivedAPIEvent,
  triggerPhoneCapturedAPIEvent
} from 'modules/api/events'
import { trackWidgetImpression } from 'modules/impressions/utils'
import { hasMessageAttribute } from 'modules/message/utils'
import { Message } from 'types/message'
import { WidgetImpressionSource } from 'types/targeting'
import { extractPhoneNumbers } from 'utils/phone'

import AgentMessageEventBuffer from '../messageEventBuffer'

export const evaluateChatMessage = (payload: { body?: { data: Message }}) => {
  const message = payload.body.data

  AgentMessageEventBuffer.push(message)

  triggerMessageReceivedAPIEvent(message)

  if (hasMessageAttribute(message, 'isBot')) {
    return evaluateBotChatMessage(message)
  }
}

export const evaluateEndUserResponseChatMessage = (message: Message) => {
  if (hasMessageAttribute(message, 'buttonClicked')) {
    triggerButtonClickedAPIEvent(message)
  }

  if (!!message.body) {
    const phoneNumbers = extractPhoneNumbers(message.body)
    if (phoneNumbers && !!phoneNumbers.length) {
      phoneNumbers.forEach((number) => {
        triggerPhoneCapturedAPIEvent(message, number)
      })
    }
  }
}

export const evaluateBotChatMessage = (message: Message) => {
  if (hasMessageAttribute(message, 'offerSchedule') || hasMessageAttribute(message, 'presentSchedule')) {
    const schedulingTargetAgentId = message.attributes.offerSchedule || message.attributes.presentSchedule
    triggerMeetingRequestedAPIEvent(schedulingTargetAgentId)
    trackWidgetImpression(WidgetImpressionSource.CALENDAR_DROP)
  }
}
